import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlurListenerDirective } from './blur-stats.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BlurListenerDirective],
  exports: [BlurListenerDirective]
})
export class BlurListenerModule { }